import React, { Component } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import shortfetch from "../../components/data/fetch";
import LoadingBar from "../../components/data/loading";

class TreinenOverzicht extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data_array: {},
      isLoading: true,
    };
  }

  async GetTrainData() {
    let post_json = {
      type: "get_train_data",
      auth: localStorage.getItem("auth"),
    };
    console.log(JSON.stringify(post_json));

    let data = await shortfetch(post_json);

    console.log("fetched_data", data);

    this.setState({
      data_array: data,
      isLoading: false,
    });
  }

  componentDidMount() {
    this.GetTrainData();
  }

  render() {
    if (this.state.isLoading) {
      return <LoadingBar />;
    }

    const { history } = this.props;

    return (
      <TableContainer
        component={Paper}
        style={{ margin: 8, width: "calc( 100% - 16px)" }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Fabrieksomschrijving</TableCell>
              <TableCell align="right">Schaal</TableCell>
              <TableCell align="right">Fat&nbsp;(g)</TableCell>
              <TableCell align="right">Carbs&nbsp;(g)</TableCell>
              <TableCell align="right">Protein&nbsp;(g)</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {this.state.data_array.map((row) => (
              <TableRow
                key={row.TrainID}
                onClick={() => history.push("/Trein/" + row.TrainID)}
                style={{ cursor: "pointer" }}
              >
                <TableCell component="th" scope="row">
                  {row.TrainName}
                </TableCell>
                <TableCell align="right">{row.TrainScale}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }
}

export default TreinenOverzicht;
